import React, {useEffect, useState} from 'react';
import clsx from 'clsx';

import './circleRangePage.scss';
import {Sparkle} from '../../../../assets';

const CircleRangeSliderPage = ({min, max, onChange, valueSecurity, colorBg}) => {
  const [value, setValue] = useState(min);
  const radius = 65;
  const strokeWidth = 10;

  const percentageToDegrees = (percentage) => {
    return percentage * 360;
  };

  useEffect(() => {
    let currentValue = min;
    const increment = (valueSecurity - currentValue) / 100;

    const animate = () => {
      currentValue += increment;
      if (currentValue < valueSecurity) {
        setValue(currentValue);
        setTimeout(animate, 10);
      } else {
        setValue(valueSecurity);
      }
    };

    animate();
  }, [valueSecurity, min]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    onChange(newValue);
  };

  const circumference = 2 * Math.PI * (radius - strokeWidth / 2);
  const strokeLength = ((value - min) / (max - min)) * circumference;

  return (
    <div
      className={clsx('circle-range-wrapper', {
        full: value === 100,
      })}>
      {value === 100 && (
        <>
          <div className="sparkle-wrapper1">
            <Sparkle />
          </div>
          <div className="sparkle-wrapper2">
            <Sparkle />
          </div>
          <div className="sparkle-wrapper3">
            <Sparkle />
          </div>
          <div className="sparkle-wrapper4">
            <Sparkle />
          </div>
        </>
      )}
      <div className="circle-range-slider-page">
        <div className="circle-range-slider-title">{valueSecurity}</div>
        <svg width={'100%'} height={'100%'}>
          <circle
            className="circle-range-slider_bg_sircule"
            cx={radius}
            cy={radius}
            r={radius - strokeWidth / 2}
            // stroke={colorBg}
            strokeWidth={strokeWidth}
            fill="none"
          />
          <circle
            cx={radius}
            cy={radius}
            r={radius - strokeWidth / 2}
            stroke={colorBg}
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={`${strokeLength} ${circumference}`}
            strokeLinecap="round"
            transform={`rotate(-90 ${radius} ${radius})`}
          />
        </svg>
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          disabled
          className="circle-range-input"
        />
      </div>
    </div>
  );
};

export default CircleRangeSliderPage;
